if (!customElements.get('cart-delivery-widget')) {
  customElements.define('cart-delivery-widget', class CartDeliveryWidget extends HTMLElement {
    connectedCallback() {
      const configEl = this.querySelector('script[type="application/json"]');
      this.config = configEl ? JSON.parse(configEl.textContent) : {};
      this.render();
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
    }

    render() {
      if (this._timer) clearInterval(this._timer);
      const dates = this.calculateDates();
      this.updateDescription(dates);
      this.updateSteps(dates);
      this.startTimer(dates.cutoff);
    }

    calculateDates() {
      const now = new Date();
      const c = this.config;

      const todayCutoff = new Date(now);
      todayCutoff.setHours(c.cutoff_hour, c.cutoff_minute, 0, 0);

      // Timer always counts to the next cutoff: today's if not yet passed, tomorrow's if already passed
      const cutoff = new Date(todayCutoff);
      if (now > todayCutoff) cutoff.setDate(cutoff.getDate() + 1);

      // Order date shifts to tomorrow once today's cutoff passes
      let orderDate = new Date(now);
      orderDate.setHours(0, 0, 0, 0);
      if (now > todayCutoff) orderDate.setDate(orderDate.getDate() + 1);

      const procDays = this.buildDayArray('proc');
      const transitDays = this.buildDayArray('transit');
      const blocked = this.parseBlockedDates(c.blocked_dates);

      const processingStart = this.nextWorkingDay(orderDate, procDays, blocked);
      const processingFrom = this.addWorkingDays(processingStart, c.processing_min, procDays, blocked);
      const processingTo = this.addWorkingDays(processingStart, c.processing_max, procDays, blocked);

      const deliveryFrom = this.addWorkingDays(processingFrom, c.transit_min, transitDays, []);
      const deliveryTo = this.addWorkingDays(processingTo, c.transit_max, transitDays, []);

      return { ordered: orderDate, processingFrom, processingTo, deliveryFrom, deliveryTo, cutoff };
    }

    buildDayArray(prefix) {
      const c = this.config;
      const map = { mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 0 };
      return Object.entries(map).filter(([key]) => c[`${prefix}_${key}`]).map(([, val]) => val);
    }

    nextWorkingDay(date, workingDays, blocked) {
      let d = new Date(date);
      for (let i = 0; i < 14; i++) {
        if (workingDays.includes(d.getDay()) && !this.isBlocked(d, blocked)) return new Date(d);
        d.setDate(d.getDate() + 1);
      }
      return new Date(d);
    }

    addWorkingDays(start, count, workingDays, blocked) {
      if (count <= 0) return new Date(start);
      let d = new Date(start);
      let added = 0;
      while (added < count) {
        d.setDate(d.getDate() + 1);
        if (workingDays.includes(d.getDay()) && !this.isBlocked(d, blocked)) added++;
      }
      return d;
    }

    isBlocked(date, blocked) {
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yyyy = date.getFullYear();
      return blocked.some(b => b === `${yyyy}-${mm}-${dd}` || b === `${mm}-${dd}`);
    }

    parseBlockedDates(str) {
      if (!str) return [];
      return str.split('\n').map(l => l.trim()).filter(l => l);
    }

    formatDate(date) {
      const c = this.config;
      const d = String(date.getDate()).padStart(2, '0');
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const y = date.getFullYear();
      const sep = c.date_separator || '/';
      if (c.date_format === 'MM/DD/YYYY') {
        return c.include_year ? `${m}${sep}${d}${sep}${y}` : `${m}${sep}${d}`;
      }
      return c.include_year ? `${d}${sep}${m}${sep}${y}` : `${d}${sep}${m}`;
    }

    stepDate(date) {
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${months[date.getMonth()]} ${date.getDate()}`;
    }

    updateDescription(dates) {
      const desc = this.querySelector('[data-delivery-description]');
      if (!desc) return;

      const from = this.formatDate(dates.deliveryFrom);
      const to = this.formatDate(dates.deliveryTo);
      let text = (this.config.description_template || '');
      text = text.replace(/{counter}/g, '<strong data-timer class="cart-delivery-timer"></strong>');
      text = text.replace(/{delivery_from}/g, `<strong>${from}</strong>`);
      text = text.replace(/{delivery_to}/g, `<strong>${to}</strong>`);
      desc.innerHTML = text;
    }

    updateSteps(dates) {
      const s1 = this.querySelector('[data-step-date="1"]');
      const s2 = this.querySelector('[data-step-date="2"]');
      const s3 = this.querySelector('[data-step-date="3"]');
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

      if (s1) s1.textContent = this.stepDate(dates.ordered);
      if (s2) s2.textContent = this.stepDate(dates.processingFrom);

      if (s3) {
        const f = dates.deliveryFrom;
        const t = dates.deliveryTo;
        if (f.getTime() === t.getTime()) {
          s3.textContent = this.stepDate(f);
        } else if (f.getMonth() === t.getMonth()) {
          s3.textContent = `${months[f.getMonth()]} ${f.getDate()} - ${t.getDate()}`;
        } else {
          s3.textContent = `${this.stepDate(f)} - ${this.stepDate(t)}`;
        }
      }
    }

    startTimer(cutoff) {
      const timerEl = this.querySelector('[data-timer]');
      if (!timerEl) return;

      const update = () => {
        const remaining = cutoff - new Date();
        if (remaining <= 0) {
          clearInterval(this._timer);
          this.render();
          return;
        }
        const h = Math.floor(remaining / 3600000);
        const m = Math.floor((remaining % 3600000) / 60000);
        const s = Math.floor((remaining % 60000) / 1000);
        timerEl.textContent = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      };

      update();
      this._timer = setInterval(update, 1000);
    }
  });
}
